<template>
  <v-text-field
    ref="inputRef"
    type="text"
    :maxlength="8"
    :label="label"
    prefix="R$"
    dense
    required
    outlined
    :error="error"
    :error-messages="errorMessages"
    @keydown.enter="$emit('submit')"
  />
</template>

<script>
import { watch } from '@vue/composition-api'
import { useCurrencyInput } from 'vue-currency-input'

export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { inputRef, setValue } = useCurrencyInput({
      currency: 'BRL',
      autoDecimalDigits: true,
      currencyDisplay: 'hidden',
    })

    watch(
      () => props.value,
      (value) => {
        setValue(value)
      }
    )

    return { inputRef }
  },
}
</script>
